const validNSSRegExp = /^(\d{2})(\d{2})(\d{2})\d{5}$/;

const validNSS = (rfc: string): boolean => validNSSRegExp.test(rfc);

export default validNSS;
